import { render, staticRenderFns } from "./PhysicalAlbums.vue?vue&type=template&id=07376f66&scoped=true"
import script from "./PhysicalAlbums.vue?vue&type=script&lang=js"
export * from "./PhysicalAlbums.vue?vue&type=script&lang=js"
import style0 from "./PhysicalAlbums.vue?vue&type=style&index=0&id=07376f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07376f66",
  null
  
)

export default component.exports